var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-percent-pond',{staticClass:"h-100",attrs:{"config":_vm.rateConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }